/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardSchemePriceOverride } from './CardSchemePriceOverride';
import {
    CardSchemePriceOverrideFromJSON,
    CardSchemePriceOverrideFromJSONTyped,
    CardSchemePriceOverrideToJSON,
    CardSchemePriceOverrideToJSONTyped,
} from './CardSchemePriceOverride';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface PaymentFeeDto
 */
export interface PaymentFeeDto {
    /**
     * 
     * @type {Date}
     * @memberof PaymentFeeDto
     */
    activeFrom: Date;
    /**
     * 
     * @type {Array<CardSchemePriceOverride>}
     * @memberof PaymentFeeDto
     */
    cardSchemePriceOverrides: Array<CardSchemePriceOverride>;
    /**
     * 
     * @type {Date}
     * @memberof PaymentFeeDto
     */
    created: Date;
    /**
     * 
     * @type {Currency}
     * @memberof PaymentFeeDto
     */
    currency: Currency;
    /**
     * 
     * @type {string}
     * @memberof PaymentFeeDto
     */
    fixedFeeAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentFeeDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentFeeDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {Date}
     * @memberof PaymentFeeDto
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentFeeDto
     */
    variableFeePercentage: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentFeeDto
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentFeeDto
     */
    locationId?: number | null;
}



/**
 * Check if a given object implements the PaymentFeeDto interface.
 */
export function instanceOfPaymentFeeDto(value: object): value is PaymentFeeDto {
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('cardSchemePriceOverrides' in value) || value['cardSchemePriceOverrides'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('fixedFeeAmount' in value) || value['fixedFeeAmount'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    if (!('variableFeePercentage' in value) || value['variableFeePercentage'] === undefined) return false;
    return true;
}

export function PaymentFeeDtoFromJSON(json: any): PaymentFeeDto {
    return PaymentFeeDtoFromJSONTyped(json, false);
}

export function PaymentFeeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentFeeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'activeFrom': (new Date(json['activeFrom'])),
        'cardSchemePriceOverrides': ((json['cardSchemePriceOverrides'] as Array<any>).map(CardSchemePriceOverrideFromJSON)),
        'created': (new Date(json['created'])),
        'currency': CurrencyFromJSON(json['currency']),
        'fixedFeeAmount': json['fixedFeeAmount'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'updated': (new Date(json['updated'])),
        'variableFeePercentage': json['variableFeePercentage'],
        'activeTo': json['activeTo'] === undefined ? undefined : json['activeTo'] === null ? null : (new Date(json['activeTo'])),
        'locationId': json['locationId'] === undefined ? undefined : json['locationId'] === null ? null : json['locationId'],
    };
}

export function PaymentFeeDtoToJSON(json: any): PaymentFeeDto {
    return PaymentFeeDtoToJSONTyped(json, false);
}

export function PaymentFeeDtoToJSONTyped(value?: PaymentFeeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activeFrom': value['activeFrom'].toISOString(),
        'cardSchemePriceOverrides': ((value['cardSchemePriceOverrides'] as Array<any>).map(CardSchemePriceOverrideToJSON)),
        'created': value['created'].toISOString(),
        'currency': CurrencyToJSON(value['currency']),
        'fixedFeeAmount': value['fixedFeeAmount'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'updated': value['updated'].toISOString(),
        'variableFeePercentage': value['variableFeePercentage'],
        'activeTo': value['activeTo'] == null ? value['activeTo'] : value['activeTo'].toISOString(),
        'locationId': value['locationId'],
    };
}

